import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import { IoCall } from "react-icons/io5";
import { MdOutlineMarkEmailUnread } from "react-icons/md";
import menu from "../../hooks/menu.json";
import { map } from "jquery";
import { Link } from "react-router-dom";


const Header = () => {


    const getMenuItems = (item, link) => {
        if (!link) link = '';
        if (item.id)
            link += '/' + item.id;
        return (
            <li className="nav-item" key={item.id || item.name}>
                <Link to={(link != '/aplicaciones' && link != '/productos') ? link : ''} className="nav-link toggle">{item.name}<i className={!item.page && item.items && item.items.length > 0 && "bx bxs-chevron-down" || ''} /></Link>
                {!item.page && item.items && item.items.length > 0 && <ul className="dropdown-menu">
                    {map(item.items, (subItem) => getMenuItems(subItem, link))}
                </ul>}
            </li>
        );

    };

    return (
        <header className="header-area">
            <div className="header-top header-top-one">
                <div className="container">
                    <div className="header-left">

                    </div>
                    <div className="header-right">
                        <IoCall className="ml-5" /> +54 (11) 4760-6060
                        <MdOutlineMarkEmailUnread className="ml-4" /> <a target="_blank" href="mailto:ventas@ares.com.ar" rel="noreferrer">ares@ares.com.ar</a>
                    </div>
                </div>
            </div>
            <div className="main-navbar-area">
                <div className="main-responsive-nav">
                    <div className="container">
                        <div className="main-responsive-menu">
                            <div className="logo">
                                <Link to="/">
                                    <img src={process.env.PUBLIC_URL + "/assets/img/logo.png"} className="w-50" alt="logo" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="main-nav">
                    <div className="container">
                        <nav className="navbar navbar-expand-md navbar-light">
                            <Link className="navbar-brand" to="/">
                                <img src={process.env.PUBLIC_URL + "/assets/img/logo.png"} className="w-50" alt="Logo" />
                            </Link>
                            <div className="collapse navbar-collapse mean-menu">
                                <ul className="navbar-nav ml-auto">
                                    {menu.map((item) => getMenuItems(item))}
                                    <li className="nav-item">
                                        <Link to="/servicios" className="nav-link">Servicios</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/descargas" className="nav-link">Descargas</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/nosotros" className="nav-link">Nosotros</Link>
                                    </li>
                                    <li className="nav-item">
                                        <Link to="/contacto" className="nav-link">Contacto</Link>
                                    </li>
                                </ul>
                            </div>

                        </nav>
                    </div>
                </div>
            </div>
        </header>

    );
}
export default Header;